
import React from 'react';
import { FileText, Download, Share2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { DocumentWithRelations } from '@/types/custom-types';

export interface DocumentPreviewProps {
  document: DocumentWithRelations;
  onDownload: () => void;
  onShare: () => void;
}

export function DocumentPreview({ document, onDownload, onShare }: DocumentPreviewProps) {
  const getFileIcon = () => {
    if (document.file_type?.includes('pdf')) {
      return <FileText className="h-16 w-16 text-red-500" />;
    } else if (document.file_type?.includes('image')) {
      return <FileText className="h-16 w-16 text-blue-500" />;
    } else if (document.file_type?.includes('word') || document.file_type?.includes('doc')) {
      return <FileText className="h-16 w-16 text-indigo-500" />;
    } else if (document.file_type?.includes('excel') || document.file_type?.includes('sheet')) {
      return <FileText className="h-16 w-16 text-green-500" />;
    } else {
      return <FileText className="h-16 w-16 text-gray-500" />;
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Document Preview</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center p-8 border-t">
        {document.file_type?.includes('image') ? (
          <img 
            src={`/api/documents/${document.id}/preview`} 
            alt={document.title} 
            className="max-w-full max-h-[500px] rounded-md"
          />
        ) : (
          <div className="text-center p-8 w-full">
            <div className="bg-muted/30 rounded-lg p-10 flex flex-col items-center justify-center">
              {getFileIcon()}
              <h3 className="mt-4 text-lg font-medium">{document.title}</h3>
              <p className="mt-2 text-muted-foreground">
                Preview not available for this file type
              </p>
              <div className="flex space-x-2 mt-6">
                <Button onClick={onDownload}>
                  <Download className="mr-2 h-4 w-4" /> Download
                </Button>
                <Button variant="outline" onClick={onShare}>
                  <Share2 className="mr-2 h-4 w-4" /> Share
                </Button>
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
